import React from 'react'
import { createRoot } from 'react-dom/client'
import App from './App'
import * as serviceWorker from './serviceWorker'
import { Provider } from 'react-redux';
import { store } from './store/store';
import './styles/global.scss'
import { ToastProvider } from '../src/components/ToastContext';
import { ConfirmProvider } from './components/ConfirmContext';
const fontStyle = document.createElement('style');
fontStyle.innerHTML = `
    @import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&display=swap');
    body {
        font-family: 'Inter', sans-serif;
    }
`;
document.head.appendChild(fontStyle);
const root = createRoot(document.getElementById('root')!)
root.render(
    <Provider store={store}>
        <ToastProvider>
            <ConfirmProvider>
                <App />
            </ConfirmProvider>
        </ToastProvider>
    </Provider>
);

serviceWorker.unregister()
